import React from "react";
import { LoginCallback, useOktaAuth } from "@okta/okta-react";
import {
  BrowserRouter,
  Route as ReactRouterRoute,
  Redirect,
  Switch,
} from "react-router-dom";
import { LoginView } from "auth/components/LoginView";
import { LogoutView } from "auth/components/LogoutView";
import { isOktaEnabled } from "auth/utils/oktaAuth";
import { CheckoutsView } from "checkouts/components/CheckoutsView";
import { Route } from "core/components/Route";
import { LOGIN_CALLBACK_PATHNAME, LOGIN_PATHNAME } from "core/constants";
import { useErrorReporterFiltered } from "core/hooks/useErrorReporterFiltered";
import { HistoryView } from "history/components/HistoryView";
import { QualityAuditsEmailConfigurationView } from "quality_audits_email_configuration/components/QualityAuditsEmailConfigurationView";
import { ReportsView } from "reports/components/ReportsView";
import { ScheduleView } from "schedule/components/ScheduleView";
import { SupervisorsView } from "supervisors/components/SupervisorsView";
import { StandaloneCreateTaskView } from "tasks/components/StandaloneCreateTaskView";
import { StandaloneTaskView } from "tasks/components/StandaloneTaskView";
import { TasksView } from "tasks/components/TasksView";
import { TeamView } from "team/components/TeamView";

// TODO: Delete this if 5.2.3 solves PKCE.
// IF any errorReporter comes in here, we know to keep this.
// https://github.com/okta/okta-oidc-js/issues/898#issuecomment-884204267
const OktaAuthLoginCallback = () => {
  const errorReporter = useErrorReporterFiltered();
  const { oktaAuth } = useOktaAuth();
  return (
    <LoginCallback
      errorComponent={({ error }) => {
        errorReporter.notify(error);
        const id = setTimeout(() => {
          localStorage.removeItem("okta-cache-storage");
          localStorage.removeItem("okta-token-storage");
          window.location.replace("/");
        }, 2000);
        oktaAuth.signOut().then(() => {
          clearTimeout(id);
        });
        return null;
      }}
    />
  );
};

export const Router = () => (
  <BrowserRouter>
    <Switch>
      {isOktaEnabled && (
        <ReactRouterRoute
          component={OktaAuthLoginCallback}
          path={LOGIN_CALLBACK_PATHNAME}
        />
      )}
      {!isOktaEnabled && (
        <Route
          exact
          component={LoginView}
          path={LOGIN_PATHNAME}
          title="Sonder | Login"
        />
      )}
      {!isOktaEnabled && (
        <Route
          exact
          component={LogoutView}
          path="/logout"
          title="Sonder | Logout"
        />
      )}
      <Route
        exact
        requireAuth
        component={ReportsView}
        path="/reports"
        title="Sonder | Reports"
      />
      <Route
        exact
        requireAuth
        component={ScheduleView}
        path="/schedule"
        title="Sonder | Schedule"
      />
      <Route
        exact
        requireAuth
        component={HistoryView}
        path="/history"
        title="Sonder | History"
      />
      <Route
        requireAuth
        component={TasksView}
        path="/tasks"
        title="Sonder | Tasks"
      />
      <Route
        requireAuth
        component={CheckoutsView}
        path="/checkouts"
        title="Sonder | Checkouts"
      />
      <Route
        requireAuth
        component={StandaloneCreateTaskView}
        path="/task/create"
        title="Sonder | Create Task"
      />
      <Route
        requireAuth
        component={StandaloneTaskView}
        path="/task/:taskId"
        title="Sonder | Task"
      />
      <Route
        requireAuth
        component={TeamView}
        path="/team"
        title="Sonder | Team"
      />
      <Route
        requireAuth
        component={SupervisorsView}
        path="/supervisors"
        title="Sonder | Cleaning Supervisors"
      />
      <Route
        requireAuth
        component={QualityAuditsEmailConfigurationView}
        path="/quality_audits_email_configuration"
        title="Sonder | Quality Audits Email Configuration"
      />
      <Redirect to="/tasks" />
    </Switch>
  </BrowserRouter>
);
